import advertisingManagement from './service';
export default {
    advertisingManagement
};